// MyFilter.js
import Vue from 'vue'
import * as patient from "./utils/patient";
import * as item from "./utils/item";
import * as disaster from "./utils/disaster";
import * as inspection from "./utils/inspection";

Vue.filter('directionFilter', value => {
  if (value === true) {
    return '医師処方値変更あり'
  }
  return '医師処方値変更なし'
})

Vue.filter('roleFilter', value => {
  if (value === 7) {
    return '待機当番のみ'
  } else if (value === 6) {
    return '営業管理者'
  } else if (value === 5) {
    return 'GSS管理者'
  } else if (value === 4) {
    return '点検者'
  } else if (value === 3) {
    return '点検管理者'
  } else if (value === 2) {
    return 'コールセンター'
  } else if (value === 1) {
    return 'システム管理者'
  } else {
    return 'N/A'
  }
})

Vue.filter('inspectionOrderFilter', value => {
  if (value === 0) {
    return '設置'
  } else if (value === 1) {
    return '定期点検'
  } else if (value === 2) {
    return 'メンテナンス'
  } else if (value === 3) {
    return 'リースアップ'
  } else if (value === 4) {
    return '緊急対応'
  } else {
    return '-'
  }
})

Vue.filter('inspectionStatusFillter', value => {
  if (value === 6) {
    return '点検完了'
  } else if (value === 1) {
    return 'アポ未実施'
  } else if (value === 2) {
    return 'アポ実施済'
  } else if (value === 3) {
    return '点検中'
  } else if (value === 4) {
    return '新規作成(画面遷移用の一時ステータス。登録後は直ぐにアポ未実施になる。）'
  } else if (value === 5) {
    return '取り消し'
  } else {
    return ''
  }
})

Vue.filter('shippingStatusFillter', value => {
  if (value === 0) {
    return '未確定'
  } else if (value === 1) {
    return '確定'
  } else if (value === 2) {
    return '未登録'
  } else if (value === 3) {
    return '登録済'
  } else {
    return ''
  }
})

Vue.filter('urgentStatusFillter', value => {
  if (value === 0) {
    return '新規作成'
  } else if (value === 1) {
    return '支店依頼中'
  } else if (value === 2) {
    return '支店回答済み'
  } else if (value === 3) {
    return '完了'
  } else if (value === 4) {
    return '取下げ'
  } else if (value === 5) {
    return '作成中'
  } else {
    return 'unknown'
  }
})

Vue.filter('supportOfficeDealTypeFilter', value => {
  if (value === '0') {
    return '不明'
  } else if (value === '1') {
    return '1 不満 （不適切）'
  } else if (value === '2') {
    return '2 やや不満 (やや不適切)'
  } else if (value === '3') {
    return '3 普通'
  } else if (value === '4') {
    return '4 やや満足（やや適切）'
  } else if (value === '5') {
    return '5 満足  (適切)'
  }
})

Vue.filter('travelStatusFillter', value => {
  if (value === 1) {
    return '予定'
  } else if (value === 2) {
    return '旅行終了'
  } else if (value === 3) {
    return 'キャンセル'
  } else if (value === 5) {
    return '旅行中'
  } else if (value === 4) {
    return '完了'
  } else if (value === 6) {
    return '新規追加'
  }
})

Vue.filter('travelTypeFillter', value => {
  if (value === 1) {
    return '個人旅行'
  } else if (value === 2) {
    return 'ツアー参加'
  }
})

Vue.filter('sendTypeFillter', value => {
  if (value === 1) {
    return '手持ち'
  } else if (value === 2) {
    return '送付'
  } else if (value === 3) {
    return 'N/A'
  } else if (value === 4) {
    return 'PCP公開'
  } else if (value === 5) {
    return 'ナビエク郵送'
  }
})
Vue.filter('sendTypePatientFillter', value => {
  if (value === 1) {
    return '手持ち'
  } else if (value === 2) {
    return '送付'
  } else if (value === 3) {
    return '点検報告書送付不要'
  }
})
Vue.filter('sendTypeFillterCommon', (value, printType) => {
  if (value === 1) {
    return '手持ち'
  } else if (value === 2) {
    return '送付'
  } else if (value === 3) {
    switch (printType) {
      case 1:
        return '点検報告書送付不要';
      case 2:
        return 'N/A'
    }
  } else if (value === 4) {
    return 'PCP公開'
  } else if (value === 5) {
    return 'ナビエク郵送'
  }
});

Vue.filter('printingKindFillter', value => {
  if (value === 1) {
    return '患者'
  } else if (value === 2) {
    return '医療機関'
  }
})

Vue.filter('inspectionTypeFillter', value => {
  if (value === 0) {
    return '院内 / 当社点検有'
  } else if (value === 1) {
    return '院内 / 当社点検無し'
  } else if (value === 2) {
    return '在宅 / 当社点検'
  } else if (value === 3) {
    return '在宅 / ディーラー点検'
  } else if (value === 4) {
    return '院内・在宅 / RR点検不要'
  } else if (value === 5) {
    return '社内器'
  }else if (value === 6) {
    return 'フリーメンテ'
  }
})

Vue.filter('printingStatusFillter', (value) => {
  if (value === 1) {
    return '印刷済'
  } else if (value === 2) {
    return '未出力'
  } else if (value === 3) {
    return '確認済'
  } else if (value === 4) {
    return 'PCP公開済'
  } else if (value === 5) {
    return 'ナビエク郵送済'
  } else if (value === 6) {
    return 'PCP閲覧済'
  }
})

Vue.filter('anpyLevelFilter', value => {
  if (value === "1") {
    return 'S : NPPV 24h（マスク）'
  } else if (value === "2") {
    return 'A : TPPV 24h（気切）'
  } else if (value === "3") {
    return 'B : TPPV 夜間のみ（気切）'
  } else if (value === "4") {
    return 'C : NPPV 夜間のみ（マスク）'
  } else if (value === "5") {
    return 'D：HOT24h（設定値３L以上）'
  } else if (value === "6") {
    return 'E：HOT24h（設定値３L未満）'
  }
})

Vue.filter('regularDisposablesStatusFilter', (value, flg) => {
  if (flg) {
    return '発送対象外'
  }
  if (value === 0) {
    return '未確定'
  } else if (value === 1) {
    return '確定'
  }
})

Vue.filter('existenceFilter', value => {
  let name;
  if (value) {
    name = '有';
  } else {
    name = '無';
  }
  return name;
});

Vue.filter('useFilter', value => {
  let name;
  if (value) {
    name = '使用する';
  } else {
    name = '使用しない';
  }
  return name;
});

Vue.filter('deletedFilter', value => {
  let name;
  if (value) {
    name = '削除';
  } else {
    name = '';
  }
  return name;
});

Vue.filter('coEaFilter', value => {
  let name;
  if (value === "ケアオーケストレーター") {
    name = 'CO';
  } else {
    name = 'EA';
  }
  return name;
});

Vue.filter('expendableFilter', value => {
  const expendable = Object.values(item.EXPENDABLE_TYPE_MAP).find((expendable) => expendable.code == value);
  return expendable ? expendable.name : "";
  });

Vue.filter('genderFilter', value => {
  const gender = Object.values(patient.GENDER_MAP).find((gender) => gender.code == value);
  return gender ? gender.name : "";
});

Vue.filter('infectionFilter', value => {
  const infection = Object.values(patient.INFECTION_TYPE_MAP).find((infection) => infection.code == value);
  return infection ? infection.name : "";
});

Vue.filter('directDestinationTypeFilter', value => {
  const directDestinationType = Object.values(patient.DIRECT_DESTINATION_TYPE_MAP).find((directDestinationType) => directDestinationType.code == value);
  return directDestinationType ? directDestinationType.name : "";
});

Vue.filter('accessoryFilter', value => {
  const accessory = Object.values(item.ACCESSORY_TYPE_MAP).find((accessory) => accessory.code == value);
  return accessory ? accessory.name : "";
});

Vue.filter('disasterSupportStatusSummaryFilter', value => {
  const elem = Object.values(disaster.DISASTER_SUPPORT_STATUS_SUMMARY_MAP).find((elem) => elem.code == value);
  return elem ? elem.name : "";
});

Vue.filter('disasterContactStatusFilter', value => {
  const status = Object.values(disaster.DISASTER_CONTACT_STATUS_MAP).find((status) => status.code == value);
  return status ? status.name : "";
});

Vue.filter('disasterSupportStatusFilter', value => {
  const status = Object.values(disaster.DISASTER_SUPPORT_STATUS_MAP).find((status) => status.code == value);
  return status ? status.name : "";
});

Vue.filter('deliveryKindFlag', value => {
  const status = Object.values(inspection.DELIVERY_KIND_FLAG_MAP).find((status) => status.code == value);
  return status ? status.name : "";
});


// WEBPACK FOOTER //
// ./src/filters.js